<template>
  <v-row dense>
    <v-col>
      <RateSheetLineTable
      :rateSheetInteractionMode="RateSheetInteractionMode.RateSheet.View"
      :lines="sheetLines"
      :originalLines="sheetLines"
      :accountId="accountId"
      :scalingGroups="scalingGroups"
      :lineMatchResults="lineMatchResults"/>
    </v-col>
    <v-col cols="12" md="auto">
      <v-data-table
      id="base-rate-diagnosis-ticket-table"
      dense
      hide-default-footer
      fixed-header
      class="clickable-rows"
      item-key="ticketId"
      :headers="ticketHeaders"
      :items="combination.tickets"
      :items-per-page="-1"
      :height="combination.tickets.length > MAX_VISIBLE_TICKETS ? TICKET_TABLE_HEIGHT : undefined"
      @click:row="ticket => $emit('ticket-selected', ticket)"/>
    </v-col>
  </v-row>
</template>

<script>
import { RateSheetInteractionMode } from '@/components/activity/rate-sheet/RateSheet'
import { RateSheetDimension, lineDimensionResults } from '@/utils/RateSheetMatching'

const MAX_VISIBLE_TICKETS = 10
const TICKET_TABLE_HEIGHT = 330

const COLUMN_FOR_DIMENSION = {
  [RateSheetDimension.Species]: 'speciesGroup',
  [RateSheetDimension.Length]: 'lengthGroup',
  [RateSheetDimension.Diameter]: 'diameterGroup',
  [RateSheetDimension.Grade]: 'grade',
  [RateSheetDimension.EndUseSort]: 'endUseSort'
}

export default {
  name: 'BaseRateCombinationDiagnosis',

  components: {
    RateSheetLineTable: () => import('@/components/activity/rate-sheet/RateSheetLineTable.vue')
  },

  props: {
    combination: {
      type: Object,
      required: true
    },
    sheetLines: {
      type: Array,
      required: true
    },
    accountId: {
      type: Number,
      required: true
    },
    lookup: {
      type: Object,
      required: true
    },
    scalingGroups: {
      type: Object,
      required: false,
      default: null
    }
  },

  data: () => ({
    RateSheetInteractionMode,
    MAX_VISIBLE_TICKETS,
    TICKET_TABLE_HEIGHT
  }),

  computed: {
    ticketHeaders () {
      return [
        { text: this.$t('hashSign'), value: 'ticketNumber' },
        { text: this.$t('baseRateHits'), value: 'logCount', align: 'right' }
      ]
    }
  },

  methods: {
    lineMatchResults (line) {
      return Object.fromEntries(lineDimensionResults(line, this.combination, this.lookup)
        .map(result => [COLUMN_FOR_DIMENSION[result.dimension], result.matches]))
    }
  }
}
</script>

<style scoped>
.clickable-rows ::v-deep tbody > tr {
  cursor: pointer;
}
</style>
